import arrowButtonOuterLayer from '@assets/intro-screen/arrow-button-outer-layer.svg'
import arrowButtonFirstInnerLayer from '@assets/intro-screen/arrow-button-first-inner-layer.svg'
import arrowButtonInnerShadow from '@assets/intro-screen/arrow-button-inner-shadow.svg'
import arrowButtonArrow from '@assets/intro-screen/arrow-button-arrow.svg'

import React, { MouseEvent } from 'react'
import { BuildGradientStyle } from '@utils/buildGradientStyle'

type ArrowButtonProps = {
    onClick: (event: MouseEvent, number: number) => void
    innerLayerStyle: BuildGradientStyle
    disabled: boolean
    className: string
    isDecrement?: boolean
}

export const ArrowButton: React.FC<ArrowButtonProps> = (props) => {
    const { disabled, isDecrement, className, onClick, innerLayerStyle } = props

    return (
        <button
            className={className}
            onClick={(e) => onClick(e, isDecrement ? -1 : 1)}
            disabled={disabled}
            style={{ opacity: disabled ? 0.5 : 1 }}
        >
            <img src={arrowButtonOuterLayer} />
            <img className="absolute top-[4px] left-[4px]" src={arrowButtonFirstInnerLayer} />
            <div
                className="absolute left-[5.5px] top-[5.5px] h-[60px] w-[60px] rounded-[30px]"
                style={innerLayerStyle}
            ></div>
            <img className="absolute left-[5px] top-[5px]" src={arrowButtonInnerShadow} />
            <img className="absolute left-[28.2px] top-[21px]" src={arrowButtonArrow} />
        </button>
    )
}
